module.exports = __webpack_public_path__ + "img/iata1.59c01ba3.webp";